// @flow
export const questionsCount: number = 30
export const pictureInQuestionCount: number = 2
export const maxSecond: number = 30
export const fbId = 743207312503631
export const socialShareData = {
  url: 'https://10years.lifehacker.ru/picturer/',
  picture: 'https://10years.lifehacker.ru/picturer/Sharing_pikcher.jpg',
}



// WEBPACK FOOTER //
// ./src/constants/params.js